var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[(_vm.footerLink)?_c('footer-link-form',{attrs:{"footer-links":_vm.footerLinks,"footer-link":_vm.footerLink,"is-editing":true},on:{"onSubmit":_vm.handleSubmit}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }